import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=6bd2bbd0&scoped=true"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"
import style0 from "./Participants.vue?vue&type=style&index=0&id=6bd2bbd0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd2bbd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd2bbd0')) {
      api.createRecord('6bd2bbd0', component.options)
    } else {
      api.reload('6bd2bbd0', component.options)
    }
    module.hot.accept("./Participants.vue?vue&type=template&id=6bd2bbd0&scoped=true", function () {
      api.rerender('6bd2bbd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Participants.vue"
export default component.exports